import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { useLocation } from "react-router";

import { Navigation, NavLink } from "../../shared";
import { NoFavouritesDialog } from "../../../favourites/components";
import { useFavouriteItemsQuery } from "../../../favourites/api";
import messages from "./messages";

type Props = {
  parentClasses: Record<
    "root" | "toolbar" | "logo" | "leftSide" | "rightSide" | "navigation" | "dotForActiveLink" | "link" | "notHoverLink",
    string
  >;
};

export const HeaderNavigation: React.FC<Props> = (props) => {
  const { parentClasses } = props;
  const location = useLocation();
  const { data } = useFavouriteItemsQuery();
  const [noFavouritesDialogOpen, setNoFavouritesDialog] = useState(false);

  const handleFavouritesNavigation = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (data && data.length === 0) {
      e.preventDefault();
      setNoFavouritesDialog(true);
    }
  };

  return (
    <Navigation className={parentClasses.navigation}>
      <NavLink to="/" parentClasses={parentClasses} isHeaderLink>
        <FormattedMessage {...messages.home} />
        {location.pathname === "/" && <div className={parentClasses.dotForActiveLink}></div>}
      </NavLink>
      <NavLink to="/favourites" parentClasses={parentClasses} isHeaderLink onClick={handleFavouritesNavigation}>
        <FormattedMessage {...messages.favourites} />
        {location.pathname === "/favourites" && <div className={parentClasses.dotForActiveLink}></div>}
      </NavLink>
      <NavLink to="/subscriptions" parentClasses={parentClasses} isHeaderLink>
        <FormattedMessage {...messages.subscriptions} />
        {location.pathname === "/subscriptions" && <div className={parentClasses.dotForActiveLink}></div>}
      </NavLink>
      <NavLink to="/help" parentClasses={parentClasses} isHeaderLink>
        <FormattedMessage {...messages.help} />
        {location.pathname === "/help" && <div className={parentClasses.dotForActiveLink}></div>}
      </NavLink>

      <NoFavouritesDialog open={noFavouritesDialogOpen} handleCloseDialog={() => setNoFavouritesDialog(false)} />
    </Navigation>
  );
};

export default HeaderNavigation;
